import React from "react";
import GlobalForm from "../../Components/Panels/GlobalForm";
import TypesForm from "./TypesForm";
import { myEmptyType } from "./ProjectTypes.config";
import useValidator from "../../Utils/useValidator";
import Localize from "react-intl-universal";
import { projectTypeSchemma } from "../../Utils/ProjectsSchema";

const TypesRightPanel = props => {
  const { currentView, setCurrentView, currentModule, selectedItem, callGetAll } = props;

  const customProperties = {
    selectedItem,
    setCurrentView,
    currentView,
    currentModule
  };

  const [parameters, , validateOnSave, validateField, setParameters] = useValidator(
    projectTypeSchemma
  );

  const customOnSaveValidation = currentItem => {
    let validateType = validateOnSave(currentItem);

    if (validateType) {
      return true;
    }
    return false;
  };

  const customOnChangeValidation = (field, value) => {
    if (parameters && parameters[field] && parameters[field] !== "") {
      validateField(field, value);
    }
  };

  const customErrorHandler = (error, showNotificationMessage) => {
    if (error && error.response && error.response.status === 409) {
      setParameters(prevParameters => {
        return {
          ...prevParameters,
          name: Localize.get("GLOBAL.NOTIFICATIONS.NOT_UNIQUE")
        };
      });
      showNotificationMessage({
        type: "warning",
        serverMessage: Localize.get("SETTINGS.NOTIFICATIONS.ERROR_SAVED")
      });
    } else {
      showNotificationMessage({
        type: "warning",
        serverMessage: Localize.get("AUTHORIZATION.UNHANDLED_ERROR")
      });
    }
  };

  return (
    <>
      {selectedItem && currentView === "edit" && (
        <GlobalForm
          formHeaderText={"PROJECTS.TYPES.EDIT_TYPE"}
          {...customProperties}
          CustomForm={TypesForm}
          customOnSaveValidation={customOnSaveValidation}
          customOnChangeValidation={customOnChangeValidation}
          parameters={parameters}
          customErrorHandler={customErrorHandler}
        />
      )}

      {currentView === "create" && (
        <GlobalForm
          formHeaderText={"PROJECTS.TYPES.CREATE_TYPE"}
          {...{
            ...customProperties,
            selectedItem: myEmptyType
          }}
          CustomForm={TypesForm}
          emptyObject={myEmptyType}
          customOnSaveValidation={customOnSaveValidation}
          customOnChangeValidation={customOnChangeValidation}
          callGetAll={callGetAll}
          parameters={parameters}
          customErrorHandler={customErrorHandler}
        />
      )}
    </>
  );
};

export default TypesRightPanel;
